import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DatePickerTypeConfig } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/date-picker/components/date-picker-types/configs';

@Component({
  selector: 'date-picker-types',
  templateUrl: './date-picker-types.component.html',
  standalone: false,
})
export class DatePickerTypesComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  datePickerTypeConfig = [...DatePickerTypeConfig];
  constructor() {}
  ngOnDestroy() {}

  ngOnInit() {}
}
